<script setup>
import { versionCheckState, reloadToLatest } from "@/services/versionCheck";
</script>
<template>
  <div v-if="versionCheckState.updateAvailable" class="update-banner">
    <span>A new version of this dashboard is available.</span>
    <button type="button" class="btn btn-sm btn-white ms-3 mb-0" @click="reloadToLatest">
      Reload now
    </button>
  </div>
</template>
<style scoped>
.update-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  background-color: #172b4d;
  color: #fff;
  font-size: 0.875rem;
}
</style>
